module.exports = __webpack_public_path__ + "static/img/oprCt_bg_09.f292bec2.svg";